import {
    FETCH_INVITATION,
    FETCH_INVITATIONS,
} from '../actions/invitation';


export const initialState = {
    isFetching: true,
    data: null
};

export const invitations = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVITATIONS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVITATIONS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



export const invitation = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVITATION}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVITATION}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/invitation.js